import React, { useRef, useState } from 'react';
import styles from './DateFilter.module.scss';
import { BodySectionContainer, LabeledInput, DateRangePicker, Button } from 'components/common';
import { icons } from 'assets';

const DateFilter = ({ period, setPeriod }) => {
  const [showDatePicker, setShowDatePicker] = useState(false);
  const anchorRef = useRef<HTMLDivElement>(null);
  // const [period, setPeriod] = useState(null);
  const getFormatedDateRange = (value: any) => {
    if (!value) return '';

    const DATE_FORMAT = 'DD/MM/YYYY';
    const startDate = value.start.format(DATE_FORMAT);
    const endDate = value.end.format(DATE_FORMAT);
    return `${startDate} - ${endDate}`;
  };

  return (
    <BodySectionContainer title='Added at' className={styles.container}>
      <div ref={anchorRef}>
        <LabeledInput
          placeholder='Pick period'
          onClick={() => setShowDatePicker(!showDatePicker)}
          value={getFormatedDateRange(period)}
          icon={icons.calendar}
          size='mini'
          className={styles.input}
        />
      </div>
      <Button
        className={styles.optionButton}
        onClick={() => setPeriod(null)}
        type='cancel'
      >
        Reset period
      </Button>
      <DateRangePicker
        visible={showDatePicker}
        setVisibility={v => setShowDatePicker(v)}
        initialValue={period}
        onSelect={setPeriod}
        anchorRef={anchorRef}
      />
    </BodySectionContainer>
  );
};

export default DateFilter;
